export const PAGE_SIZE_OPTION = [10, 20, 30]
export const TOKEN_FAILED = ['TOKEN_EXPIRED', 'INVALID_TOKEN']
